import { render } from "./SliderItemSport.vue?vue&type=template&id=50b238e2"
import script from "./SliderItemSport.vue?vue&type=script&lang=js"
export * from "./SliderItemSport.vue?vue&type=script&lang=js"

import "./SliderItemSport.vue?vue&type=style&index=0&id=50b238e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__